import script from "./Nav.vue?vue&type=script&lang=ts&setup=true"
export * from "./Nav.vue?vue&type=script&lang=ts&setup=true"

import "./Nav.vue?vue&type=style&index=0&id=5b473e6a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\33\\Desktop\\2024\\block-explorer-ts\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b473e6a"]])

export default __exports__